import { Validators } from "@angular/forms";
import { SzamlazzhuInvoiceControls, SzamlazzhuInvoiceForm } from "../form.controls";
import { FormFactory } from "../form.factory";
import { SzamlazzhuInvoice } from "../form.resources";

export function getSzamlazzhuInvoiceForm(this: FormFactory): SzamlazzhuInvoiceForm {
  const invoice = this.data as SzamlazzhuInvoice;

  const form = this.fb.group<SzamlazzhuInvoiceControls>({
    invoice_id: this.fb.control(invoice.invoice_id, { nonNullable: true }),
    invoice_number: this.fb.control(invoice.invoice_number, { nonNullable: true }),
    total_remaining_amount: this.fb.control(invoice.total_remaining_amount, { nonNullable: true }),
    currency_iso: this.fb.control(invoice.currency_iso, { nonNullable: true }),
    file: this.fb.control(invoice.file, { validators: Validators.required }),
  });

  return form;
}
